import { render, staticRenderFns } from "./OpinionPersonalIndex.vue?vue&type=template&id=1afd56d2&scoped=true"
import script from "./OpinionPersonalIndex.vue?vue&type=script&lang=js"
export * from "./OpinionPersonalIndex.vue?vue&type=script&lang=js"
import style0 from "./OpinionPersonalIndex.vue?vue&type=style&index=0&id=1afd56d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afd56d2",
  null
  
)

export default component.exports